export function synchronousSetState(callback) {
    // Set state synchronously
    // Use like this: setState.bind({state})(myFunction)
    Object.assign(this.state, callback(this.state));
}
